module.exports = "/assets/942db6a3e39e8ecc6c9141c65e687d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PB.png
// module id = 1710
// module chunks = 0